module.exports = __webpack_public_path__ + "static/img/图片15.85846227.png";